import { render, staticRenderFns } from "./DashboardFormDialog.vue?vue&type=template&id=045e3a04&"
import script from "./DashboardFormDialog.vue?vue&type=script&lang=js&"
export * from "./DashboardFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports